<template>
  <div class="item-details item-text">
    <template v-for="(row, index) in list" :key="index">
      <template v-if="index">
        <span class="delimiter"> / </span>
      </template>
      <span v-if="row.tooltip" v-tooltip="row.tooltip" :class="row.style">
        {{ row.value }}
      </span>
      <span v-else :class="row.style">
        {{ row.value }}
      </span>
    </template>
  </div>
</template>

<script setup>
// import { PhaseEnum } from '@/helper/steam.js';
import { computed, getCurrentInstance } from 'vue';

const instance = getCurrentInstance();
const { $t } = instance.appContext.config.globalProperties;

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  exterior: {
    type: String,
    default: '',
  },
  hero: {
    type: String,
    default: '',
  },
  paint_seed: {
    type: Number,
    default: 0,
  },
});

// quality: {
//   type: String,
//  default: '',
// },
const quality = '';

const list = computed(() => {
  const data = [];
  if (props.exterior) {
    data.push({ value: props.exterior, style: 'item-exterior' });
  }
  if (quality) {
    data.push({ value: quality, style: 'item-quality' });
  }
  if (props.hero) {
    data.push({ value: props.hero, style: 'item-hero' });
  }
  if (props.paint_seed) {
    data.push({
      value: props.paint_seed,
      style: 'item-paint-seed',
      tooltip: { message: $t('common.paint_seed_value', { value: props.paint_seed }) },
    });
  }
  // if (props.item?.extras_1 && props.item?.phase_id === PhaseEnum.fade) {
  //   data.push({
  //     value: `${$t('sort.field.extras_1_fade')} ${(props.item.extras_1 / 100_000_0).toFixed(0)}%`,
  //     style: 'item-extras-value',
  //   });
  // }

  return data;
});

</script>
